import React, { useState, useEffect } from 'react';
import Dialog from '../../../../../components/Dialog/DefaultDialog';
import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/core/styles';
import SlidesContainer from './SlidesContainer';
import API from '../../../../../api/axios';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  uploadBtn: {
    textAlign: 'center',
  },
  center: {
    textAlign: 'center',
  },
}));

const SlidesDialog = (props) => {
  const classes = useStyles();
  const [slides, setSlides] = useState(props.slides);
  const [uploading, setUploading] = useState(false);
  const { open, onSave, onClose, showMessage, sliderId, onDeleteSlide } = props;
  const handleSelectFiles = (e) => {
    const files = e.target.files;
    let slides2 = [];
    for (let [key, value] of Object.entries(files)) {
      slides.push({
        key,
        attachment: value,
        title: '',
        description: '',
        link: '',
      });
    }
    slides.length > 0 && setSlides([...slides, ...slides2]);
  };
  const handleChangeSlidesFields = (key, name, value) => {
    slides[key][name] = value;
    setSlides([...slides]);
  };
  const handleOnSave = async () => {
    setUploading(true);
    try {
      let data = new FormData();
      for (let { title, description, link, attachment } of slides.filter(
        (slide) => slide.key !== undefined
      )) {
        data.set('sliderId', sliderId);
        data.set('title', title ? title : ' ');
        data.set('description', description ? description : ' ');
        data.set('link', link ? link : '#');
        data.set('attachment', attachment);
        await API.post(`/api/v1/admin/slider/slide`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      showMessage(1, '', '', 'با موفقیت انجام پذیرفت');
      onSave();
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
      showMessage(2, '', '', 'بروز خطا');
      onClose();
    }
    setUploading(false);
  };
  const handleOnDeleteSlide = (slideId) => {
    onDeleteSlide(slideId);
  };

  useEffect(() => {
    setSlides(props.slides);
  }, [props.slides]);

  return (
    <Dialog
      open={open}
      title={uploading ? false : 'افزودن اسلاید جدید به اسلایدر'}
      save={uploading ? false : 'آپلود و ذخیره اسلایدها'}
      cancel={uploading ? false : 'صرفنظر'}
      onSave={handleOnSave}
      onClose={onClose}
    >
      <div className={classes.dialogContainer}>
        {uploading ? (
          <div className={classes.center}>
            <CircularProgress />
            <br />
            در حال آپلود اسلایدها ...
          </div>
        ) : (
          <>
            <div className={classes.uploadBtn}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<CloudUploadIcon />}
                component="label"
              >
                آپلود تصاویر اسلاید
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleSelectFiles}
                  style={{ display: 'none' }}
                  multiple
                />
              </Button>
            </div>
            <div className={classes.slidesContainer}>
              {!!slides && (
                <SlidesContainer
                  slides={slides}
                  sliderId={sliderId}
                  onChangeField={handleChangeSlidesFields}
                  onDeleteSlide={handleOnDeleteSlide}
                />
              )}
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default SlidesDialog;
